import { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; 
import "../reachus.css";
import CalendlyComponent from "../Components/Calendly";

const ReachUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Message sent!");
  };

  const handleMeetingBooking = (e) => {
    e.preventDefault();
    alert(`Meeting booked on ${selectedDate.toLocaleDateString()}!`);
  };

  return (
    <div className="reach-us">
      <div className="reach-us-banner">
        <h1>Get In Touch</h1>
        <p>We're here to help. Reach out to us anytime!</p>
      </div>
      <div className="reach-us-content">
        <div className="contact-form">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="number"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit" className="submit-btn">
              Send Message
            </button>
          </form>
        </div>
       
        <div className="calendar-booking">
          {/* <h2>Book a Meeting</h2> */}
          {/* <form onSubmit={handleMeetingBooking}>
            <label>Select a Date</label>
            <Calendar
              value={selectedDate}
              onChange={setSelectedDate}
              minDate={new Date()}
              tileClassName={({ date, view }) => 
                date.toDateString() === selectedDate.toDateString() ? "react-calendar__tile--active" : null
              }
            />
            
            <button type="submit" className="book-meeting-btn">
              Book Meeting
            </button>
          </form> */}
          <CalendlyComponent />
        </div>
       
      </div>
      
    </div>
  );
};

export default ReachUs;
